import { useModalBox } from '../../contexts'

import * as S from './styles'

const Modal = () => {
  const {
    content,
    open,
    setContent,
    setOpen,
    customModalClose,
    setCustomModalClose,
    title,
    setTitle,
    width,
    height,
    noCloseButton
  } = useModalBox()

  const handleClose = () => {
    setOpen(false)
    setContent(null)
    setTitle(null)
    if (customModalClose) {
      customModalClose()
      setCustomModalClose(null)
    }
  }

  if (!open) return null

  return (
    <>
      <S.ModalDialogOverlay onClick={handleClose} />
      <S.ModalDialogContent width={width} height={height}>
        <S.ModalDialogHeader className="title-modal">
          {title && (
            <S.ModalDialogHeaderTitle>{title}</S.ModalDialogHeaderTitle>
          )}
          {!noCloseButton && (
            <S.ModalDialogClose onClick={handleClose}>
              &times;
            </S.ModalDialogClose>
          )}
        </S.ModalDialogHeader>
        <S.ModalDialogBody>{content}</S.ModalDialogBody>
        <S.ModalDialogFooter />
      </S.ModalDialogContent>
    </>
  )
}

export default Modal
